<script>

    export let title = ''
    export let subtitle = ''
    export let loading = false
    export let error = false
    export let empty = false
    export let emptyText = 'Sin cotizaciones en el periodo'

</script>

<style>
    .card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.35rem 1.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        transition: opacity 0.15s ease;
    }

    .card.is-loading {
        opacity: 0.55;
    }

    .header {
        margin-bottom: 1.25rem;
    }

    .title {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0;
        line-height: 1.2;
    }

    .subtitle {
        font-size: 0.85rem;
        color: #9e9e9e;
        margin: 0.25rem 0 0;
    }

    .state {
        margin: 0;
        padding: 1.5rem 0;
        text-align: center;
        font-size: 0.9rem;
        color: #9e9e9e;
    }

    .state.is-error {
        color: #dc2626;
    }
</style>

<div class="card" class:is-loading={loading}>
    <div class="header">
        <h3 class="title">{ title }</h3>
        {#if subtitle}
            <p class="subtitle">{ subtitle }</p>
        {/if}
    </div>

    {#if error}
        <p class="state is-error">No se pudo cargar la información</p>
    {:else if empty}
        <p class="state">{ emptyText }</p>
    {:else}
        <slot></slot>
    {/if}
</div>
